import type {Context} from '../types';

// Fix up legacy sites to change 'full' to 'section'
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, tag} = jsonNode;
  const gridType = tag === 'div' && data.grid && data.grid.type;

  return {
    needed: gridType === 'full',
    logData: {
      msg: 'Grid with data.grid.type "full"',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.grid.type = 'section';
    },
  };
};
